<script>
  import { AUDIO_PATH, AUDIO_ENDING } from "../model/Config";
  import AudioButton from "./AudioButton.svelte";
  import { _ } from "svelte-i18n";
  import { beforeUpdate } from "svelte";
  import { HtmlSanitizer } from "../helper/Sanitizer";
  import { fade } from "svelte/transition";
  import Icon from "fa-svelte";
  import { faArrowDown } from "@fortawesome/free-solid-svg-icons/faArrowDown";
  import { faArrowUp } from "@fortawesome/free-solid-svg-icons/faArrowUp";
  import { replace } from "svelte-spa-router";
  import { getImgSrcOfData, getMiniSrcOfData } from "../helper/ImgHelper";
  import LazyImage from "./LazyImage.svelte";

  export let data;
  export let selectedLink;
  export let subTopic = null;
  export let withImg = false;
  export let language;
  export let additionalClasses = "md:w-6/12 lg:w-4/12";

  let sanitizedText;
  let sanitizedList;
  let expanded;
  let imgSrc;
  let bgColor;
  let minSrc;
  beforeUpdate(() => {
    if (data) {
      if (data.text) {
        sanitizedText = HtmlSanitizer.SanitizeHtml(data.text);
      } else {
        sanitizedText = null;
      }
      if (data.list) {
        sanitizedList = HtmlSanitizer.SanitizeHtml(data.list);
      } else {
        sanitizedList = null;
      }
    }
    imgSrc = getImgSrcOfData(data);
    minSrc = getMiniSrcOfData(data);
    if (selectedLink === "letters") {
      bgColor = `bg_bili-${language.value}`;
    } else {
      bgColor = `bg_${selectedLink}-${language.value}`;
    }
  });
  function linkTo() {
    if (data.link) {
      if (subTopic && subTopic.value) {
        replace("/" + data.link + "/" + subTopic.value);
      } else {
        replace("/" + data.link);
      }
    }
  }
  function onExpand() {
    expanded = !expanded;
  }
</script>

<style>
  .text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
</style>

{#if data}
  <div class="{additionalClasses} flex flex-wrap px-1 lg:px-4 w-full">
    <div
      class="p-2 sm:p-10 justify-center shadow-lg rounded-lg glass w-full {bgColor}">
      {#if withImg}
        <LazyImage src={imgSrc} placeholder={minSrc} />
      {/if}
      <div class="w-full transition text-center justify-center">
        <h2 class="text-xl uppercase block font-semibold">
          {$_(`languages.${language.value}`)}
        </h2>
        <h1 class="text-lg pt-4 font-semibold">
          {#if data.audio_title}
            <AudioButton
              audio={AUDIO_PATH + 'custom/' + data.audio_title + AUDIO_ENDING} />
          {:else}
            <AudioButton
              audio={AUDIO_PATH + 'laute/' + subTopic.value + '_laut_' + language.value + AUDIO_ENDING} />
          {/if}
          {data.title}
        </h1>

        {#if data.audio_l}
          <AudioButton
            audio={AUDIO_PATH + 'custom/' + data.audio_l + AUDIO_ENDING} />
        {:else if sanitizedList}
          <AudioButton
            audio={AUDIO_PATH + 'ws/' + subTopic.value + '_ws_' + language.value + AUDIO_ENDING} />
        {/if}
        <div class="contentList">
          {#if sanitizedList}
            {@html sanitizedList}
          {/if}
        </div>
        {#if sanitizedText}
          <br />
          <hr />
          {#if data.audio_t}
            <AudioButton
              audio={AUDIO_PATH + 'custom/' + data.audio_t + AUDIO_ENDING} />
          {:else}
            <AudioButton
              audio={AUDIO_PATH + 'texte/' + subTopic.value + '_text_' + language.value + AUDIO_ENDING} />
          {/if}
          <!-- <div class="content {expanded ? '' : 'text'}"> -->
          <div class="contentText">
            {@html sanitizedText}
          </div>
          <!-- <button
            on:click={onExpand}
            class="text-white text-base font-semibold py-2 px-4  flex-shrink-0 rounded-lg shadow-md hover:bg-accent-300 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:ring-opacity-50">
            <Icon icon={expanded ? faArrowUp : faArrowDown} />
            {expanded ? 'less' : 'more'}</button> -->
        {/if}
        {#if data.link}
          <button
            on:click={linkTo(data.link)}
            class=" 
          p-2
           transition duration-500 ease-in-out uppercase
          text-gray-600  bg-primary-300 border rounded-full transform 
           hover:bg-accent-100 hover:-translate-y-1 hover:scale-110
           focus:bg-accent-100 focus:-translate-y-1 focus:scale-110">
            {$_('letter.topic_button')}
          </button>
        {/if}
      </div>
    </div>
  </div>
{/if}
